"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeRenderContextualStylesMenu = void 0;
var react_1 = __importDefault(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var PropertyControls_1 = require("Project/QwilrEditor/RegistryElement/PropertyControls");
var UseOnStyleChangeHandler_1 = require("Project/QwilrEditor/RegistryElement/UseOnStyleChangeHandler");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var pathsToExclude = ["color", "size", "alignment"];
var maybeRenderContextualStylesMenu = function (_a) {
    var selectedTextWidgets = _a.selectedTextWidgets, widgetManager = _a.widgetManager;
    if (!selectedTextWidgets[0])
        return null;
    if (!areWidgetsSameType(selectedTextWidgets))
        return null;
    var filteredProperties = selectedTextWidgets[0].styleableConfig.properties.filter(function (p) { return !pathsToExclude.includes(p.path); });
    if (filteredProperties.length === 0) {
        return null;
    }
    return (react_1.default.createElement(ContextualStylesMenu, { selectedTextWidgets: selectedTextWidgets, widgetManager: widgetManager, filteredProperties: filteredProperties }));
};
exports.maybeRenderContextualStylesMenu = maybeRenderContextualStylesMenu;
var ContextualStylesMenu = function (_a) {
    var selectedTextWidgets = _a.selectedTextWidgets, widgetManager = _a.widgetManager, filteredProperties = _a.filteredProperties;
    (0, tiny_invariant_1.default)(!!selectedTextWidgets[0], "Did you miss a conditional check in maybeRenderContextualStylesMenu?");
    var firstWidget = selectedTextWidgets[0];
    var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: firstWidget.element.type, traitName: "styleable" });
    (0, tiny_invariant_1.default)(!!styleableConfig, "ContextualStylesMenu could not get styleable trait for ".concat(firstWidget.element.type));
    var onChangeHandler = (0, UseOnStyleChangeHandler_1.useOnStyleChangeHandler)({
        elements: selectedTextWidgets.map(function (_a) {
            var element = _a.element;
            return element;
        }),
        widgetManager: widgetManager,
    });
    return (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { className: tokens_1.darkTheme, size: kaleidoscope_1.PopoverSize.Small, padding: "small", button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({ icon: react_1.default.createElement(icons_1.OptionsHorizontal, null), tooltip: { content: "More options" } }, buttonProps))); }, autoStack: true },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m" }, filteredProperties.map(function (p) {
            return (react_1.default.createElement(PropertyControls_1.PropertyControls, { key: p.path, element: firstWidget.element, property: p, style: firstWidget.style, onChangeHandler: onChangeHandler }));
        }))));
};
function areWidgetsSameType(selectedTextWidgets) {
    var e_1, _a;
    var seenTypes = new Set();
    try {
        for (var selectedTextWidgets_1 = __values(selectedTextWidgets), selectedTextWidgets_1_1 = selectedTextWidgets_1.next(); !selectedTextWidgets_1_1.done; selectedTextWidgets_1_1 = selectedTextWidgets_1.next()) {
            var w = selectedTextWidgets_1_1.value;
            if (w.element.type === "listItem") {
                seenTypes.add("listItem-".concat(w.element.data.listType));
            }
            else {
                seenTypes.add(w.element.type);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (selectedTextWidgets_1_1 && !selectedTextWidgets_1_1.done && (_a = selectedTextWidgets_1.return)) _a.call(selectedTextWidgets_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return seenTypes.size === 1;
}
